import {
  APP_BRAND_PLP_ROUTE,
  APP_CATALOG_ROUTE,
  APP_CATEGORY_ROUTE,
  APP_CUSTOM_PLP_ROUTE,
  APP_EMPLOYEE_CUSTOMERS_LIST,
  APP_SEARCH_ROUTE,
  NUMBER_1,
  CHECKOUT_STEPS_ROUTE,
  ORDER_STEP_ADDRESS,
  ORDER_STEP_PAYMENT,
  ORDER_STEP_REVIEW,
  ORDER_STEP_THANKYOU,
  BUY_AGAIN,
  YOUR_ASSORTMENT,
} from '~shared/constants';
import { DEFAULT_OFFSET } from '~app/modules/generic/constants';
import { USER_TYPE_KEY } from '~app/core/modules/identity/constants/identity.constant';

const firstRegexMatch = 1;
const secondRegexMatch = 2;
const thirdRegexMatch = 3;

const EMPLOYEE_HEADER_PAGES = [
  `/${APP_EMPLOYEE_CUSTOMERS_LIST}`,
  `/${CHECKOUT_STEPS_ROUTE}`,
  `/${CHECKOUT_STEPS_ROUTE}/${ORDER_STEP_ADDRESS}`,
  `/${CHECKOUT_STEPS_ROUTE}/${ORDER_STEP_PAYMENT}`,
  `/${CHECKOUT_STEPS_ROUTE}/${ORDER_STEP_REVIEW}`,
  `/${CHECKOUT_STEPS_ROUTE}/${ORDER_STEP_THANKYOU}`,
];

export namespace UrlUtils {
  export function isProductListPage(url: string): boolean {
    return isCatalogPage(url)
      || isCategoryPage(url)
      || isSearchPage(url)
      || isCustomPLPPage(url)
      || isBrandPlpPage(url);
  }

  export function isCategoryPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url.startsWith(`/${APP_CATEGORY_ROUTE}/`);
  }

  export function isCatalogPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url.startsWith(`/${APP_CATALOG_ROUTE}`);
  }

  export function isSearchPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }
    return url.startsWith(`/${APP_SEARCH_ROUTE}`);
  }

  export function isCustomPLPPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`/${APP_CUSTOM_PLP_ROUTE}`);
  }

  export function isBrandPlpPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`/${APP_BRAND_PLP_ROUTE}`);
  }

  export function isBuyAgainPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`${BUY_AGAIN}`);
  }

  export function isYourAssortmentPage(url: string): boolean {
    if (!isValidUrl(url)) {
      return false;
    }

    return url.startsWith(`${YOUR_ASSORTMENT}`);
  }

  export function getCategoryFromUrl(url: string): string {
    if (!isValidUrl(url)) {
      return null;
    }

    const matches = url.match(/f.categories.0=([^&]*)|\/c\/([^&!?]*)*/);
    if (!matches) {
      return null;
    }
    return matches[firstRegexMatch] || matches[secondRegexMatch];
  }

  export function getCurrentPage(offset: number, limits: number) {
    let currentPage = NUMBER_1;

    if ((offset && limits) && (offset !== DEFAULT_OFFSET)) {
      currentPage = (offset / limits) + 1;
    }

    return currentPage;
  }

  export function getSlugFromUrl(url: string): string {
    if (!isValidUrl(url)) {
      return null;
    }

    const path = url.split('?').shift();
    return path.split('/')[secondRegexMatch];
  }

  export function getBrandPathFromUrl(url: string): string {
    if (!isValidUrl(url)) {
      return null;
    }

    const brandSlug = this.getSlugFromUrl(url);
    return `/${APP_BRAND_PLP_ROUTE}/${brandSlug}`;
  }

  export function getProductIdFromUrl(url: string): string {
    if (!isValidUrl(url)) {
      return null;
    }

    return url.split('/').pop();
  }

  function isValidUrl(url: string): boolean {
    if (!url) {
      console.warn('Trying to access products list page with url: null');
      return false;
    }
    return true;
  }

  export function getIsEmployeeRestrictedView(url: string): boolean {
    const isEmployeeRestrictedPage = EMPLOYEE_HEADER_PAGES.includes(url);
    const isEmployee = localStorage.getItem(USER_TYPE_KEY) === 'EMP';
    const isEmployeeRestrictedView = isEmployee && isEmployeeRestrictedPage;

    return isEmployeeRestrictedView;
  }
}
